export const BookShipmentDedicatedLogisticsOfferButtonPositionType = {
  Top: 0,
  Inline: 1,
} as const;
export type BookShipmentDedicatedLogisticsOfferButtonPositionType =
  (typeof BookShipmentDedicatedLogisticsOfferButtonPositionType)[keyof typeof BookShipmentDedicatedLogisticsOfferButtonPositionType];
